import { useState } from 'react'
import { ChatMessage, MessageSender, MessageType } from '../ChatMessages'
import { useLocaleText } from '../locale'

export const useChatMessages = () => {
  const t = useLocaleText()

  const introMessages: ChatMessage[] = [
    {
      sender: MessageSender.Agent,
      type: MessageType.Suggestions,
      content: {
        title: t('concierge_chat.quick_prompts_title'),
        suggestions: [
          t('concierge_chat.sample_question_1'),
          t('concierge_chat.sample_question_2'),
          t('concierge_chat.sample_question_3'),
        ],
        source: 'intro',
      },
    },
  ]

  const [messages, setMessages] = useState<ChatMessage[]>(introMessages)

  const addUserMessage = (message: string) => {
    const newMessage: ChatMessage = {
      sender: MessageSender.User,
      type: MessageType.Text,
      content: message,
    }
    setMessages(prev => [...prev, newMessage])
  }

  const appendMessages = (messagesToAppend: ChatMessage[]) => {
    setMessages(prev => [...prev, ...messagesToAppend])
  }

  const setInitialMessages = () => {
    setMessages(introMessages)
  }

  const appendErrorMessage = () => {
    appendMessages([
      {
        sender: MessageSender.Agent,
        type: MessageType.Text,
        content: t('concierge_chat.error_message'),
      },
    ])
  }

  return {
    messages,
    appendMessages,
    setInitialMessages,
    appendErrorMessage,
    addUserMessage,
    setMessages,
  }
}
